import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useHistory, useLocation } from "react-router";
import moment from "moment";

import { APPLICATION_GLOBAL_SLUG, DATE_FORMAT, URLS } from "_config";
import { useUserApi } from "_common/hooks/actions/user/appUserApiHook";
import { useToaster } from "_common/hooks/actions/common/appToasterHook";
import FormMaskedInput from "_common/components/form-elements/maskedInput/maskedInput";
import FormTextInput from "_common/components/form-elements/textinput/formTextInput";
import DateInput from "_common/components/form-elements/datepicker/dateInput";
import Sponsor from "../common/Sponsor";
import { useAppGameDetailsSelector } from "_common/hooks/selectors/eventSelector";

interface LoginFormValues {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  display_name: string;
  phone: any;
  dob: any;
}

const RegisterForm = () => {
  const location: any = useLocation();
  const userApi = useUserApi();
  const toast = useToaster();
  const history = useHistory();
  const [geoLocation, setGeoLocation] = useState<any>(null);
  const gameId = useAppGameDetailsSelector()?.id;
  const [registrationFieldsData, setRegistrationFieldsData] = useState<any>([]);
  const fields: any = {
    first_name: "First Name",
    last_name: "Last Name",
    email: "Email Address",
    password: "Password",
    dob: "Date of Birth",
    display_name: "Big Screen Display Name",
    phone: "Mobile Number",
  };

  useEffect(() => {
    getRegistrationFieldsData();
  }, []);

  const getRegistrationFieldsData = () => {
    const data = {
      gameId,
    };
    userApi.callGetRegistrationFieldsData(
      data,
      (message: string, resp: any) => {
        if (resp) {
          const sortedResp = resp.sort((a: any, b: any) => a.field_id - b.field_id);
          setRegistrationFieldsData(sortedResp);
        } else {
          toast.error(message);
        }
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  const generateValidationSchema = () => {
    const schema: any = {};
    registrationFieldsData.forEach((field: any) => {
      console.log({ field });
      if (field.is_required) {
        schema[field.registration_field.name] = yup
          .string()
          .required(`${fields[field.registration_field.name]} is required`);
      } else {
        schema[field.registration_field.name] = yup.string();
      }
    });
    return yup.object().shape(schema);
  };

  const { control, handleSubmit, errors } = useForm<LoginFormValues>({
    resolver: yupResolver(generateValidationSchema()),
    defaultValues: {
      first_name: "",
      last_name: "",
      email: "",
      password: "",
      display_name: "",
      phone: location?.state?.phone ? location?.state?.phone : "",
      dob: "",
    },
  });

  const registrationSubmit = (data: any) => {
    console.log({ data });
    if (data?.display_name) {
      data["username"] = data.display_name;
      delete data.display_name;
    }
    if (data?.dob) {
      data["dobDate"] = moment(data?.dob).format("DD");
      data["dobMonth"] = moment(data?.dob).format("MM");
      data["dobYear"] = moment(data?.dob).format("YYYY");
    }
    const mobileNoDigit = data.phone && data.phone.replace(/\D/g, "").slice(-10);
    if (mobileNoDigit) {
      data["phone"] = parseInt(mobileNoDigit);
    }
    else if (location?.state?.phone) {
      data["phone"] = location?.state?.phone;
    }
    data["game_slug"] = APPLICATION_GLOBAL_SLUG;
    if (location?.state?.isblock) {
      data["isblock"] = location?.state?.isblock;
    }
    if (geoLocation) {
      data["lat"] = geoLocation.lat;
      data["lng"] = geoLocation.lng;
    }
    userApi.callRegistration(
      data,
      (message: string, resp: any) => {
        if (resp) {
          toast.success("Your registration has been successfully completed");
          history.push(URLS.RODEOS);
        } else {
          toast.error(message);
        }
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position: any) => {
          const { latitude, longitude } = position.coords;
          setGeoLocation({ lat: latitude, lng: longitude });
        },
        (_error: any) => {
          setGeoLocation({ lat: null, lng: null });
        }
      );
    } else {
      setGeoLocation({ lat: null, lng: null });
    }
  }, []);

  return (
    <form onSubmit={handleSubmit(registrationSubmit)}>
      <div className="">
        <div className="container">
          <img src="images/logo.png" alt="#" />

          <div className="login-form-field">
            <div className="row">
              <div className="col-12">
                {registrationFieldsData.map((field: any) => {
                  if (!field.is_enable) return null;
                  switch (field.registration_field.name) {
                    case "first_name":
                      return (
                        <div className="login-form-field-inner mt-3" key={field.field_id}>
                          <Controller
                            control={control}
                            name="first_name"
                            render={({ onChange, onBlur, value, name: _name, ref }) => (
                              <FormTextInput
                                name={_name}
                                onChange={onChange}
                                onBlur={onBlur}
                                value={value}
                                inputRef={ref}
                                type={"text"}
                                error={errors.first_name}
                                placeholder="First Name"
                              />
                            )}
                          />
                          <img src="images/user.png" alt="#" />
                        </div>
                      );
                    case "last_name":
                      return (
                        <div className="login-form-field-inner mt-3" key={field.field_id}>
                          <Controller
                            control={control}
                            name="last_name"
                            render={({ onChange, onBlur, value, name: _name, ref }) => (
                              <FormTextInput
                                name={_name}
                                onChange={onChange}
                                onBlur={onBlur}
                                value={value}
                                inputRef={ref}
                                type={"text"}
                                error={errors.last_name}
                                placeholder="Last Name"
                              />
                            )}
                          />
                          <img src="images/user.png" alt="#" />
                        </div>
                      );
                    case "email":
                      return (
                        <div className="login-form-field-inner mt-3" key={field.field_id}>
                          <Controller
                            control={control}
                            name="email"
                            render={({ onChange, onBlur, value, name: _name, ref }) => (
                              <FormTextInput
                                name={_name}
                                onChange={onChange}
                                onBlur={onBlur}
                                value={value}
                                inputRef={ref}
                                type={"text"}
                                error={errors.email}
                                placeholder="Email Address"
                              />
                            )}
                          />
                          <img src="images/@-sing.png" alt="#" />
                        </div>
                      );
                    case "password":
                      return (
                        <div className="login-form-field-inner mt-3" key={field.field_id}>
                          <Controller
                            control={control}
                            name="password"
                            render={({ onChange, onBlur, value, name: _name, ref }) => (
                              <FormTextInput
                                name={_name}
                                onChange={onChange}
                                onBlur={onBlur}
                                value={value}
                                inputRef={ref}
                                type={"password"}
                                error={errors.password}
                                placeholder="Password"
                              />
                            )}
                          />
                          <img src="images/lock.png" alt="#" />
                        </div>
                      );
                    case "dob":
                      return (
                        <div className="login-form-field-inner mt-3" key={field.field_id}>
                          <Controller
                            control={control}
                            name="dob"
                            render={({ onChange, onBlur, value, name: _name, ref }) => (
                              <DateInput
                                onChange={(e) => {
                                  onChange(e);
                                }}
                                onBlur={onBlur}
                                value={value}
                                maxDate={new Date()}
                                dateFormat={DATE_FORMAT}
                                inputRef={ref}
                                error={errors.dob}
                                placeholder="Date of Birth"
                              />
                            )}
                          />
                          <img src="images/user.png" alt="#" />
                        </div>
                      );
                    case "display_name":
                      return (
                        <div className="login-form-field-inner mt-3" key={field.field_id}>
                          <Controller
                            control={control}
                            name="display_name"
                            render={({ onChange, onBlur, value, name: _name, ref }) => (
                              <FormTextInput
                                name={_name}
                                onChange={onChange}
                                onBlur={onBlur}
                                value={value}
                                inputRef={ref}
                                type={"text"}
                                error={errors.display_name}
                                placeholder="Big Screen Display Name"
                              />
                            )}
                          />
                          <img src="images/user.png" alt="#" />
                        </div>
                      );
                    case "phone":
                      return (
                        <div className="login-form-field-inner mt-3" key={field.field_id}>
                          <Controller
                            control={control}
                            name="phone"
                            render={({ onChange, onBlur, value, name: _name, ref }) => (
                              <FormMaskedInput
                                name={_name}
                                mask={"(999) 999 9999"}
                                maskChar=" "
                                onChange={onChange}
                                onBlur={onBlur}
                                value={value}
                                inputRef={ref}
                                type="tel"
                                placeholder="Mobile Number (Optional)"
                                error={errors.phone}
                              />
                            )}
                          />
                          <img src="images/mob-.png" alt="#" />
                        </div>
                      );
                    default:
                      return null;
                  }
                })}
                <div className="go-btn mt-3">
                  <button type="submit" className="btn">
                    Let&apos;s Go!
                  </button>
                </div>
                <div className="join-sec">
                  <p>
                    Already Joined?{" "}
                    <Link to={URLS.LOGIN_WITH_EMAIL} className="back-history">
                      Login
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Sponsor />
    </form>
  );
};

export default RegisterForm;
